import { Header, AMPHeaderAndSideBar, HeaderWithSubMenus } from 'mm-ui-components';
import { useSelector } from 'react-redux';
import React from 'react';
import { getPrimaryHeader } from '../../store/primaryHeader/primaryHeader.selectors';
import { getSecondaryHeader } from '../../store/secondaryHeader/secondaryHeader.selectors';
import { getHeaderWithSubMenus } from '../../store/headerWithSubMenus/headerWithSubMenus.selectors';

export const HeaderConnected: React.FunctionComponent = () => {
  const primaryHeader = useSelector(getPrimaryHeader);
  const secondaryHeader = useSelector(getSecondaryHeader);

  return <Header {...{ primaryHeader, secondaryHeader }} />;
};

export const AMPHeaderConnected: React.FunctionComponent = () => {
  const primaryHeader = useSelector(getPrimaryHeader);
  const secondaryHeader = useSelector(getSecondaryHeader);

  return <AMPHeaderAndSideBar {...{ primaryHeader, secondaryHeader }} />;
};

export const HeaderWithSubMenusConnected: React.FunctionComponent = () => {
  const headerWithSubMenus = useSelector(getHeaderWithSubMenus);
  return <HeaderWithSubMenus {...headerWithSubMenus} />;
};
